import { RoundTableText } from '../roundTableText/RoundTableText'

import styles from './RoundTableDialogContent.module.scss'

const EXPLANATIONS = [
  { name: 'shared', icon: 'kbase-lvl-session' },
  { name: 'unchanged', icon: 'kbase-document' },
  { name: 'changeLater', icon: 'kbase-settings-alt' },
] as const

interface IDialogProps {
  adding: boolean
  error: boolean
}

export const RoundTableDialogContent = ({ adding, error }: IDialogProps) => (
  <div className={styles.dialog}>
    {adding ? (
      <>
        <p>
          <RoundTableText name="review" />
        </p>
        {EXPLANATIONS.map(({ name, icon }) => (
          <div className={styles.explanation} key={name}>
            <i className={`kbase ${icon}`} aria-hidden />
            <RoundTableText name={name} />
          </div>
        ))}
      </>
    ) : (
      <>
        <p>
          <RoundTableText name="removed" />
        </p>
        <p>
          <RoundTableText name="removedLabels" />
        </p>
      </>
    )}
    {error && (
      <p role="alert">
        <RoundTableText name="error" />
      </p>
    )}
  </div>
)
